export const SOCIAL_MEDIA = {
  TELEGRAM: 'https://t.me/rps_chain',
  TWITTER: 'https://x.com/rps_chain',
  DISCORD: 'https://discord.com/invite/TseJBCj6NT',
};
